import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app-settings';
import { EventosService } from 'src/app/services/eventos.service';

@Component({
  selector: 'app-dialog-price-min',
  templateUrl: './dialog-price-min.component.html',
  styleUrls: ['./dialog-price-min.component.scss']
})
export class DialogPriceMinComponent {

  useCustomPrice: boolean = false;
  customFromPrice: number | null = null;
  loading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { event: any },
    private dialogRef: MatDialogRef<DialogPriceMinComponent>,
    private eventService: EventosService
  ) {
    if (data?.event?.custom_from_price != null) {
      this.useCustomPrice = true;
      this.customFromPrice = data.event.custom_from_price;
    }
  }

  save() {
    if (this.loading) { return; }
    const payload = {
      custom_from_price: this.useCustomPrice ? this.customFromPrice : null
    };
    this.loading = true;
    this.eventService.putEventos(this.data.event.id, payload).subscribe({
      next: (res) => {
        this.loading = false;
        this.dialogRef.close(res.data);
      },
      error: (err) => {
        this.loading = false;
        if (AppSettings.DEBUG) { console.log(err); }
      }
    });
  }
}
